import { createApp } from 'vue';
import '@common/assets/css/index.scss';
import fonts from 'google-fonts';
import { Translater } from '@common/plugins/Translater';
import App from './App.vue';

fonts.add({ 'Fira+Sans': ['300', '400', '600', '900'] });

const app = createApp(App);

app.use(Translater);
app.mount('#app');
